import React from 'react'

export default function PageLoader() {
    return <div className="flex w-full justify-center items-center h-screen bg-[#16152F]">
        <span className="loader"></span>
    </div>
}
